import { NgModule } from '@angular/core';
import { CommonModule, NgForOf, NgIf } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';

import { SchoolProgramRulesRoutingModule } from './school-program-rules-routing.module';
import { SchoolProgramRulesComponent } from './school-program-rules.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCard, MatCardContent, MatCardModule } from '@angular/material/card';
import { MatProgressSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableModule } from '@angular/material/table';
import { SelectAcademicYearOnlyModule } from 'src/shared/modules/select-academic-year-only/select-academic-year-only.module';
import { SelectSchoolLevelRelationV2Module } from 'src/shared/modules/select-school-level-relation-v2/select-school-level-relation-v2.module';
import { StatusNoDataModule } from 'src/shared/modules/status-no-data/status-no-data.module';
import { PipeModule } from 'src/shared/pipes/pipe.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxPaginationModule } from 'ngx-pagination';
import { InputCheckboxModule } from 'src/shared/modules/input-checkbox/input-checkbox.module';
import { SelectSchoolActivityModule } from 'src/shared/modules/select-school-activity/select-school-activity.module';
import { SelectSchoolProgramModule } from 'src/shared/modules/select-school-program/select-school-program.module';
import { SelectSchoolModule } from 'src/shared/modules/select-school/select-school.module';
import { SelectYearLevelRelationV2Module } from 'src/shared/modules/select-year-level-relation-v2/select-year-level-relation-v2.module';
import { StatusLoadingModule } from 'src/shared/modules/status-loading/status-loading.module';
import { RulesComponent } from '../rules/rules.component';
import { GlobalRulesComponent } from './rules-global/global-rules.component';


@NgModule({
  declarations: [SchoolProgramRulesComponent, RulesComponent, GlobalRulesComponent],
  imports: [
    CommonModule,
        FeatherModule.pick(allIcons),
    SchoolProgramRulesRoutingModule,
    CommonModule,
    SelectSchoolLevelRelationV2Module,
    FormsModule,
    MatTableModule,
    PipeModule,
    ReactiveFormsModule,
    SelectAcademicYearOnlyModule,
    MatCardModule,
    MatProgressSpinnerModule,
    StatusNoDataModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule,
    MatButtonModule,
    MatCard,
    MatCardContent,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    FaIconComponent,
    NgxDatatableModule,
    MatHeaderRow,
    NgxPaginationModule,
    MatRow,
    SelectSchoolModule,
    NgIf,
    MatHeaderRowDef,
    MatRowDef,
    MatHeaderCellDef,
    MatCellDef,
    NgForOf,
    MatPaginator,
    SelectSchoolActivityModule,
    SelectYearLevelRelationV2Module,
    SelectSchoolProgramModule,
    InputCheckboxModule,
    StatusLoadingModule,
    MatProgressSpinner,
  ],
  exports: [
    SchoolProgramRulesComponent,
    RulesComponent,
    GlobalRulesComponent
  ]
})
export class SchoolProgramRulesModule { }
